import React, { Component } from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'
import FormItem from './FormItem'
import { getAttribute } from '../utils/models'

class Date extends Component {

  state = {
    mode: this.props.mode || 'date'
  }

  handlePanelChange = (value, mode) => {
    this.setState({ mode })
  }


  render() {
    const { getFieldDecorator } = this.props.form
    const attribute = getAttribute(this.props.model, this.props.attribute)

    let inputProps = {}

    if (this.props.dateTime) {
      inputProps.showTime = { format: 'H:mm' }
      inputProps.format = 'YYYY-MM-DD HH:mm'
    }

    if (this.props.mode) {
      inputProps.mode = this.state.mode
      inputProps.onPanelChange = this.handlePanelChange.bind(this)
    }

    let { fieldSettings } = this.props

    fieldSettings.initialValue = this.props.value ? moment(this.props.value) : undefined

    return (
      <FormItem {...this.props}>
        {getFieldDecorator(this.props.attribute, fieldSettings)(
          <DatePicker
            size='large'
            disabled={this.props.disabled}
            style={{ width: '100%' }}
            allowClear={!attribute.required}
            onChange={this.props.handleChange}
            placeholder={''}
            {...inputProps}
          />
        )}
      </FormItem>
    )
  }

}

export default Date



// WEBPACK FOOTER //
// ./src/inputs/Date.js